export { default as aplyToWhitelistDialogSlice } from './aplyToWhitelistDialog';
export { default as deleteEntityDialogSlice } from './deleteEntityDialog';
export { default as confirmAplicationDialogSlice } from './confirmAplicationDialog';
